"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KoraChat = void 0;
var _react = _interopRequireDefault(require("react"));
var _OpenChatBtn = require("./OpenChatBtn");
var _hooks = require("./hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const KoraChat = () => {
  const isScriptLoaded = (0, _hooks.useSierraLoader)();
  const shouldShowOnScrolling = (0, _hooks.useShouldShowOnScrolling)();
  if (!isScriptLoaded || !shouldShowOnScrolling) return null;
  const handleOpenChatModal = () => {
    const sierra = window.sierra;
    sierra.openChatModal();
  };
  return /*#__PURE__*/_react.default.createElement(_OpenChatBtn.OpenChatBtn, {
    onClick: handleOpenChatModal
  });
};
exports.KoraChat = KoraChat;